
function trataRetorno (obj, res){
    obj.$root.setLoading(false);

    if(res.request.responseText.indexOf("<erro>")!=-1){

        var retorno = res.request.responseText.substring(
            res.request.responseText.lastIndexOf("<erro>") + 6, 
            res.request.responseText.lastIndexOf("</erro>")
        );
        
        if ((retorno=='Obrigatório informar a sessão! (KbmRouter)') ||
            (retorno=='Erro #3206 - Sessão expirada! (KbmRouter)')){
            obj.$root.setSessaoExpirada(true);
        } else {
            alert(retorno);
        }

        return {erro: retorno};

    } else {

        if ((res.request.responseText.indexOf("{")!=-1) &&
            (res.request.responseText.indexOf("}")!=-1) &&
            (res.request.responseText.indexOf(":")!=-1)){

            // para resolver esses ifs, teria que 
            // padronizar a resposta no servidor
            if (res.request.responseText.indexOf("ERRO")!=-1){
                if(JSON.parse(res.request.responseText)){
                    if(JSON.parse(res.request.responseText).ERRO){
                        alert(JSON.parse(res.request.responseText).ERRO);
                    } else {
                        return res.data;   
                    }
                } else {
                    alert(res.request.responseText);
                }
            } else {                
                return res.data;
            }
            return res.data;

        } else if(res.request.responseText.indexOf("Erro")!=-1){
            alert(res.request.responseText);
        } else
        return res.data;
    }

}

function request(obj, method, path, params){

    obj.$root.setLoading(true);

    const urlBase = 'https://www.digirotas.com/kr/';
    //const urlBase = 'http://127.0.0.1:8080/';
    
    if(method==="POST") {

        return obj.$http.post(`${urlBase}${path}`, 
            params
        )
      .then(res => {
        return trataRetorno(obj, res);
      })
      .catch(err => {
        console.log(err);
        obj.$root.setLoading(false);
      });

    } else {


        return obj.$http.get(`${urlBase}${path}?${params}&sessao=${obj.$root.getSessao()}`)  
        //return obj.$http.get(`${urlBase}/${path}?${params}&sessao=${obj.$root.getSessao()}`)       
        .then(res => {                
            return trataRetorno(obj, res);    
        })
        .catch(err => {
            console.log(err);
            obj.$root.setLoading(false);
        });
    }


}

export default request // OK!